module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "branding",
    class: [_vm.imageOrientationClass, _vm.addClass]
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.pageHref,
      "title": _vm.altText
    },
    on: {
      "click": _vm.trackEvent
    }
  }, [_c('img', {
    directives: [{
      name: "images-loaded",
      rawName: "v-images-loaded:on.progress",
      value: (_vm.imageProgress),
      expression: "imageProgress",
      arg: "on",
      modifiers: {
        "progress": true
      }
    }],
    attrs: {
      "srcset": _vm.getImgSrcSet(_vm.logo),
      "src": _vm.logo.x1.url,
      "alt": _vm.altText
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad2f28f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Branding.vue
// module id = 470
// module chunks = 1